import router from '@/router'

export const loading = state => {
    return state.loading;
};

export const isLoggedIn = state => {
    return state.isLoggedIn;
};

export const layoutConfig = state => {
    return state.layoutConfig;
};

export const getKey = state => {
    return state.key;
};

export const getBaseFontSize = state => {
    return state.baseFontSize;
}

export const getContrast = state => {
    return state.contrast || "none";
}

export const getCompanyName = state => {
    if (state.companyName) {
        return state.companyName?.toLowerCase()?.trim();
    } else {
        return router.app.$route.params.companyName?.toLowerCase()?.trim();
    }
}

export const getLocalesLang = (state, getters) => lang => {
    if (!state.locales) {
        return null
    }
    return state.locales[getters.getCompanyName][lang];
}

export const getLanguages = (state, getters) => {
    if (!state.locales) {
      return []
    }
    if (!state.locales[getters.getCompanyName])
    {
      return []
    }
    let languages = Object.keys(state.locales[getters.getCompanyName])
    if (languages && languages.length > 0 && !languages.includes('pl')) {
        languages.push('pl');
    }

    return languages
}

export const getTranslation = (state, getters) => (lang, key, defaultValue) => {
    if (!state.locales) {
        return defaultValue
    }
    try {
        var splitedKey = key.trim().split('.');
        var result = state.locales[getters.getCompanyName][lang]
        splitedKey.forEach(el => {
            result = result[el.trim()];
        })
        if (!result) {
            return defaultValue
        }
        return result;
    } catch {
        return defaultValue;
    }
}
